import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  EditOutlined,
  DeleteOutline,
  AddOutlined,
  SearchOutlined,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

//Services
import Bannerapi from "Services/Bannermanage";

//Modals
import BannerAddModal from "Pages/Modals/BannerManagement/Create";
import BannerUpdateModal from "Pages/Modals/BannerManagement/Update";
import BannerDeleteDialog from "Pages/Modals/BannerManagement/Delete";

const BannerTemplateManage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [searchText, setSearchText] = useState("");

  // Pagination
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Modals
  const [addBannerModal, setaddBannerModal] = useState(false);
  const [updateBannerModal, setupdateBannerModal] = useState(false);
  const [deleteBannerModal, setdeleteBannerModal] = useState(false);

  const handleOpenAddBannerModal = () => {
    setaddBannerModal(true);
  };

  const handleCloseBannerModal = () => {
    setaddBannerModal(false);
    getBanner();
  };

  const handleOpenUpdateBannerModal = (row) => {
    setCustomerId(row?._id);
    setupdateBannerModal(true);
  };

  const handleCloseUpdateBannerModal = () => {
    setupdateBannerModal(false);
    getBanner();
  };

  const handleOpenDeleteBannerModal = (row) => {
    setCustomerId(row?._id);
    setdeleteBannerModal(true);
  };

  const handleCloseDeleteBannerModal = () => {
    setdeleteBannerModal(false);
    getBanner();
  };

  // Get Banner list api
  const getBanner = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    const params = { page, limit: pageSize, search: searchText };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    Bannerapi.getBannerList(params).then(onSuccess, onFailure);
  }, [page, pageSize, searchText, demoaccount_id, dispatch]);

  const getallbanners = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = () => {};
    const params = { page: 1, limit: "unlimited", search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    Bannerapi.getBannerList(params).then(onSuccess, onFailure);
  }, [demoaccount_id]);

  useEffect(() => {
    getBanner();
    getallbanners();
  }, [getBanner, getallbanners]);

  const calculateSno = (pageIndex, pSize, index) => {
    return (pageIndex - 1) * pSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    BannerName: data?.BannerName,
    BannerImage: data?.BannerImage,
    row: data,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ["createdAt"], ["asc"]),
    (data, index) => ({
      sno: index + 1,
      BannerName: data?.BannerName,
    })
  );

  const formatteddatas = dataRows.map((r) => ({
    "S.NO": r.sno,
    "Banner Name": r.BannerName,
  }));

  const bulkformatteddatas = bulkdataRows.map((r) => ({
    "S.NO": r.sno,
    "Banner Name": r.BannerName,
  }));

  // Export handlers
  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All BannerList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopy = () => {
    const header = ["S.NO", "Banner Name"].join("\t");
    const rows = dataRows.map((r) => [r.sno, r.BannerName].join("\t")).join("\n");
    navigator.clipboard.writeText([header, rows].join("\n")).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Banners");
    XLSX.writeFile(workbook, "BannerList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "BannerList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((r) => [r.sno, r.BannerName]);
    doc.autoTable({
      head: [["S.NO", "Banner Name"]],
      body: tableData,
    });
    doc.save("BannerList.pdf");
  };

  // Pagination
  const totalPagesCount = Math.ceil(totalPages / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;
    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) pages.push(i);
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [0, "...", totalPagesCount - 3, totalPagesCount - 2, totalPagesCount - 1];
      } else {
        pages = [0, "...", internalPage - 1, internalPage, internalPage + 1, "...", totalPagesCount - 1];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }
      return (
        <Button
          key={item}
          className={internalPage === item ? classes.pageButtonActive : classes.pageButton}
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>Banner Templates</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Banner Templates</span>
        </Typography>
      </Box>

      {/* Action Row */}
      <Box className={classes.actionRow}>
        {/* Search */}
        <Box className={classes.searchWrapper}>
          <SearchOutlined className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search banner templates..."
            className={classes.searchInput}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
        </Box>

        {/* Right Actions */}
        <Box className={classes.rightActions}>
          {/* Add Banner Button */}
          {!demoaccount_id && (
            <Button
              variant="contained"
              className={classes.addButton}
              onClick={handleOpenAddBannerModal}
              startIcon={<AddOutlined />}
            >
              Add New Banner
            </Button>
          )}
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell}>S.No</TableCell>
              <TableCell className={classes.tableHeaderCell}>Banner Name</TableCell>
              <TableCell className={classes.tableHeaderCell}>Banner Image</TableCell>
              {!demoaccount_id && (
                <TableCell className={classes.tableHeaderCell} align="right">Actions</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{rowItem.sno}</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`}>
                  {rowItem.BannerName}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {rowItem.BannerImage ? (
                    <Box
                      component="img"
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "8px",
                        objectFit: "cover",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      }}
                      src={rowItem.BannerImage}
                      alt={rowItem.BannerName}
                    />
                  ) : (
                    "-"
                  )}
                </TableCell>
                {!demoaccount_id && (
                  <TableCell className={classes.tableCell} align="right">
                    <Box
                      component="span"
                      className={classes.actionButton}
                      onClick={() => handleOpenUpdateBannerModal(rowItem.row)}
                    >
                      <EditOutlined fontSize="small" />
                      Edit
                    </Box>
                    <Box
                      component="span"
                      className={classes.actionDeleteButton}
                      onClick={() => handleOpenDeleteBannerModal(rowItem.row)}
                    >
                      <DeleteOutline fontSize="small" />
                      Delete
                    </Box>
                  </TableCell>
                )}
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={demoaccount_id ? 3 : 4} style={{ textAlign: "center", padding: "40px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No banner templates found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination */}
        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalPages)} of {totalPages} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />
            {renderPagination()}
            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <BannerAddModal
        openDialog={addBannerModal}
        handleClose={handleCloseBannerModal}
      />
      <BannerUpdateModal
        openDialog={updateBannerModal}
        id={customerId}
        handleClose={handleCloseUpdateBannerModal}
      />
      <BannerDeleteDialog
        openDialog={deleteBannerModal}
        id={customerId}
        handleClose={handleCloseDeleteBannerModal}
      />
    </Box>
  );
};

export default BannerTemplateManage;
